'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    RatingItemContext: function() {
        return RatingItemContext;
    },
    RatingItemProvider: function() {
        return RatingItemProvider;
    },
    useRatingItemContextValue_unstable: function() {
        return useRatingItemContextValue_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reacticons = require("@fluentui/react-icons");
const RatingItemContext = /*#__PURE__*/ _react.createContext(undefined);
const ratingItemContextDefaultValue = {
    color: 'neutral',
    iconFilled: _reacticons.StarFilled,
    iconOutline: _reacticons.StarRegular,
    step: 1,
    size: 'medium'
};
const RatingItemProvider = RatingItemContext.Provider;
const useRatingItemContextValue_unstable = ()=>_react.useContext(RatingItemContext) || ratingItemContextDefaultValue;
